import * as React from 'react';
import ProductList, { LoadingProductList } from 'webapp/product/ProductList';
import { withProgressiveHydration, registerComponent, useDynamicData } from '@avensia/excite';
import GeneralProductListCarousel, {
  LoadingProductListCarousel as GeneralLoadingProductListCarousel,
} from 'nordicnest/product/ProductListCarousel';
import SvenssonsProductListCarousel, {
  LoadingProductListCarousel as SvenssonsLoadingProductListCarousel,
} from 'svenssons/product/ProductListCarousel';
import BaseContentList from 'webapp/components/BaseContentList';
import { isSvenssons } from 'webapp/theme';

export const RegisteredProductListBlock = registerComponent<NordicNest.Api.ProductListBlockApiModel>(
  withProgressiveHydration(ProductListBlock),
);

export default function ProductListBlock(props: NordicNest.Api.ProductListBlockApiModel) {
  const [products] = useDynamicData<NordicNest.Api.ProductListBlockProductsApiModel>({ context: props.context });
  const ProductListCarousel = isSvenssons ? SvenssonsProductListCarousel : GeneralProductListCarousel;
  const LoadingProductListCarousel = isSvenssons
    ? SvenssonsLoadingProductListCarousel
    : GeneralLoadingProductListCarousel;

  return (
    <BaseContentList {...props}>
      {props.carousel ? (
        products ? (
          <ProductListCarousel id={props.id ?? ''} name={props.name} products={products?.products || []} />
        ) : (
          <LoadingProductListCarousel />
        )
      ) : products ? (
        <ProductList id={props.id ?? 'product_list_block_missing_id'} name={props.name} products={products.products} />
      ) : (
        <LoadingProductList count={props.numberOfProducts} />
      )}
    </BaseContentList>
  );
}
